import React from 'react';
import ContentLoader from 'react-content-loader';
import useLadyService from '@/services/LadyService';

const MyLoader = (props) => {
	const { theme } = useLadyService();

	const gap = 12;
	const left = 12;
	const top = 20;
	const cardW = 346.5;
	const cardH = 474;

	const chipsY = cardH + gap;
	const bottomTextY = 653.89;

	return (
		<ContentLoader
			speed={2}
			width="100%"
			height="100%"
			viewBox={`0 0 ${cardW} ${bottomTextY}`}
			backgroundColor={theme === 'light' ? '#d5dddb' : '#adadad'}
			foregroundColor="#ffffff"
			{...props}
		>
			<rect
				id="rectimage"
				x="0"
				y="0"
				rx="24"
				ry="24"
				width={cardW}
				height={cardH}
			/>
			<rect
				id="rectAge"
				x={left}
				y={chipsY}
				rx="4"
				ry="4"
				width="38"
				height="49"
			/>
			<rect
				id="rectName"
				x={left + gap + 38}
				y={chipsY + 20}
				rx="4"
				ry="4"
				width={cardW / 2}
				height="10"
			/>

			<rect
				id="rectAddr"
				x={left + gap + 38}
				y={chipsY + gap + 20 + 5}
				rx="4"
				ry="4"
				width={cardW / 2 - 10}
				height="10"
			/>

			{/* <rect
				id="rectTariff"
				x={left}
				y={chipsY + gap + 49}
				rx="4"
				ry="4"
				width={(cardW - gap) / 2}
				height="36"
			/> */}

			<rect
				id="rectline"
				x={left}
				y={bottomTextY - left - 40 - gap}
				rx="0"
				ry="0"
				width={cardW - left * 2}
				height="2"
			/>

			<rect
				id="rectContacts"
				x={left}
				y={bottomTextY - left - 40}
				rx="20"
				ry="20"
				width={cardW - left * 2}
				height="40"
			/>
		</ContentLoader>
	);
};

export default MyLoader;
